/**
 * Created by 1 on 2017/10/21.
 * 数据计算工具类，一张图开发时用到的公共数学计算，不对外暴露
 */
'use strict';
define([],function(){
    //
    function isArray(obj){
        return (Object.prototype.toString.call(obj) === '[object Array]');
    }
    //
    var util={};
    /**
     * 计算 point1 和 point2 连线与x轴的夹角
     * @param point1 {Array} 必填，[x,y]
     * @param point2 {Array} 必填，[x,y]
     * @returns {Number} 单位度
     */
    util.angle=function (point1, point2) {
        var angle;
        //
        if (point2[0] === point1[0]) {
            if (point2[1] >= point1[1])
                angle = -Math.PI / 2;
            else{
                angle = Math.PI / 2;
            }
        } else{
            angle = Math.atan2(point1[1] - point2[1], point2[0] - point1[0]);
        }
        if (angle < 0)
            angle += 2 * Math.PI;
        //
        return angle * 180 / Math.PI;
    }
    /**
     * 计算线段终点上的简单箭头
     * @method
     * @param opts {Object} 必填
     * @param opts.startPt {Array} 必填，线段起点坐标，[x,y]
     * @param opts.endPt {Array} 必填，线段终点坐标，[x,y]
     * @param opts.forScreen {Boolean} 可选，是否为屏幕坐标系，默认为true；屏幕坐标系的y值需要颠倒；
     * @param opts.arrowLength {Number} 可选，箭头长度
     * @param opts.arrowScale {Number} 可选，箭头长与线段长度比，默认为0.2；
     * 		  只有未指定arrowLength参数的情况下此参数才有效；
     * @param opts.arrowAngle {Number} 可选，箭头与线段夹角，单位为度，默认为30度
     * @returns {Array} 箭头的坐标数组
     */
    util.getSimpleArrow=function(opts){
        //检查参数
        opts=opts||{};
        if(!(isArray(opts.startPt)
            &&opts.startPt.length==2
            &&isArray(opts.endPt)
            &&opts.endPt.length==2)){
            throw(new Error('参数错误！'));
        }
        //
        var startPt=opts.startPt,
            endPt=opts.endPt,
            arrowLength=opts.arrowLength,
            arrowScale=isNaN(opts.arrowScale)?0.2:opts.arrowScale,
            arrowAngle=isNaN(opts.arrowAngle)?30:opts.arrowAngle,
            forScreen=opts.forScreen===false?false:true;
        var PI=Math.PI,
            lineAngle=util.angle(endPt,startPt),
            lineLen=Math.sqrt(Math.pow(startPt[0]-endPt[0],2)+Math.pow(startPt[1]-endPt[1],2));
        //计算箭头长度
        if(isNaN(arrowLength)){
            arrowLength=lineLen*arrowScale;
        }
        var M=forScreen?-1:1;
        //获取箭头顶点
        var angle1=(lineAngle+arrowAngle)*PI/180,
            angle2=(lineAngle-arrowAngle)*PI/180,
            vertexX1=endPt[0]+Math.cos(angle1)*arrowLength,
            vertexY1=endPt[1]+M*Math.sin(angle1)*arrowLength,
            vertexX2=endPt[0]+Math.cos(angle2)*arrowLength,
            vertexY2=endPt[1]+M*Math.sin(angle2)*arrowLength;
        var points=[];
        points.push([vertexX1,vertexY1]);
        points.push([endPt[0],endPt[1]]);
        points.push([vertexX2,vertexY2]);
        return points;
    }
    return util;
});
